
import { useState } from "react";
import { IntegrationState } from "../types";

/**
 * Hook that provides shared state management for all integrations
 */
export const useIntegrationState = (): IntegrationState => {
  const [isConnected, setIsConnected] = useState(false);
  const [connectionError, setConnectionError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  return {
    isConnected,
    setIsConnected,
    connectionError,
    setConnectionError,
    isLoading,
    setIsLoading,
    isChecking,
    setIsChecking,
    isInitialized,
    setIsInitialized
  };
};
